import { Divider, styled } from '@mui/material';

import { StyledListItem } from './ControlStyles';

export const ColorDivider = styled(Divider)({
  padding: '10px',
});

export const ColorListItem = styled(StyledListItem)({
  justifyContent: 'center',
});
